import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkboxField", "quotasContainer"]

  toggleQuotaInputsVisibility() {
    if (this.checkboxFieldTarget.checked === true) {
      this.quotasContainerTarget.classList.remove("d-none")
    } else {
      this.quotasContainerTarget.classList.add("d-none")
      this.quotasContainerTarget.querySelectorAll("input[type=number]").forEach((input) => {
        input.value = ""
      })
    }
  }
}
